export enum ProfileTabEnum {
  ACCOUNT = "ACCOUNT",
  TRADING = "TRADING",
}
